import React from 'react';
import ErrorBoundaryWidgetContainer from './ErrorBoundaryWidgetContainer';

import ActivityWidgetContainer from './ActivityWidgetContainer';
import AppointmentWidgetContainer from './AppointmentWidgetContainer';
import CalendarWidgetContainer from './CalendarWidgetContainer';
import ClassWidgetContainer from './ClassWidgetContainer';
import EventsListWidgetContainer from './EventsListWidgetContainer';
import CourseWidgetContainer from './CourseWidgetContainer';
import RentalWidgetContainer from './RentalWidgetContainer';
import ReservationWidgetContainer from './ReservationWidgetContainer';
import UpcomingEventWidgetContainer from './UpcomingEventWidgetContainer';
import SearchWidgetContainer from './SearchWidgetContainer';

const ComponentsToRender = {
  ActivityWidgetContainer,
  AppointmentWidgetContainer,
  CalendarWidgetContainer,
  ClassWidgetContainer,
  EventsListWidgetContainer,
  CourseWidgetContainer,
  RentalWidgetContainer,
  ReservationWidgetContainer,
  UpcomingEventWidgetContainer,
  SearchWidgetContainer,
};

const StorefrontWidgetContainer = ({ widgetComponentName, ...props }) => {
  const ComponentToRender = ComponentsToRender[widgetComponentName];

  return (
    <ErrorBoundaryWidgetContainer widgetComponentName={widgetComponentName}>
      <ComponentToRender {...props} />
    </ErrorBoundaryWidgetContainer>
  );
};

export default StorefrontWidgetContainer;
